// flow weak

import React , { Component }                             from 'react';
  import PropTypes              from 'prop-types';
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../services/fetchTools';
  import styles                 from './style'
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog'
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  // import { CSVLink, CSVDownload } from "react-csv";
  import ReactHTMLTableToExcel from 'react-html-table-to-excel';

  
  import {
    AnimatedView,
    StatsTable,ScoreCard,StatsGraph,LocationMenu
  }                         from '../../../components';
  import {Link} from 'react-router-dom';
  import ReactTooltip from 'react-tooltip'
  import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCol,
  SmallTableHeader,
}                         from '../../../components';
import ReactTable from "react-table";
import { isNull } from 'util';
import reactDOM from "react-dom";
import {Row,Col} from "react-bootstrap";
import { Multiselect } from 'react-widgets'
import CircularProgress from 'material-ui/CircularProgress';
import locationMenu from '../../../redux/modules/locationMenu.js'
import 'react-widgets/dist/css/react-widgets.css';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import CustomerDetails from '../crud/customerDetails';
// import CancelScheduledDemo from '../crud/cancelScheduledDemo'

const customStyles = {
  content : {
    top                   : '1%',
    left                  : '1%',
    right                 : '1%',
    bottom                : '1%',  
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '10000'
   }
};

const customStyles1 = {
  content : {
    top                   : '5%',
    left                  : '5%',
    right                 : '5%',
    bottom                : '5%',  
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '10000'
   }
};
class ActiveCustomers extends Component {
    static propTypes = {
      earningGraphLabels:   PropTypes.array,
      revenueChart:  PropTypes.shape({
        headers: PropTypes.array,


        data: PropTypes.array
      }),
      earningGraphDatasets: PropTypes.array,
      teamMatesIsFetching:  PropTypes.bool,
      teamMates:            PropTypes.arrayOf(
        PropTypes.shape({
          picture:      PropTypes.string,
          firstname:    PropTypes.string,
          lastname:     PropTypes.string,
          profile:      PropTypes.string,
          profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
        })
      ),
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        open:false,
        page: 1,
        pages: 10,
        pageSize: 100,
        rowCount:0,
        inputValue:"",
        sortOption: [],
        lead_list: [],
        lead_headings: [],
        selectedLocation: props.props.scoreCard,
        isFetching: props.props.scoreCard.sales_score_card.isFetching,
        selected_name : '',
        temp_list:[],
        temp_list_game:[],
        temp_list_status:[],
        temp_list_quality:[],
        temp_list_source:[],
        venue_list: [],
        quality_list:[],
        game_list: [],
        status_list:[],
        selected_venue: [],
        selected_game: [],
        selected_status: [],
        selected_quality:[],
        selected_source:[],
        selected_date: moment(),
        search:false,
        location:props.props.scoreCard.sales_score_card.requested_venue_id,
        sortColumn:['Follow_up_date','Quality'],
        sortOrder:false,
        selected_customer_id:'',
        popUpVisible:false,
        expected_payment:false,
        date: moment().format('DD/MM/YYYY'),
        source_list:[{'source':'bbfs customer','name':'source'},{'source':'Customer App Sign Up','name':'source'},{'source':'BFC SS','name':'source'},{'source':'Facebook','name':'source'},{'source':'FB','name':'source'},{'source':'myoperator','name':'source'},{'source':'playo','name':'source'},{'source':'Sporthood Badminton - RM Nagar','name':'source'},{'source':'Sporthood Kormangala','name':'source'},{'source':'Website','name':'source'},{'source':'other','name':'source'}]
        };
      this.findHotLeads = this.findHotLeads.bind(this);
      this.onSelect = this.onSelect.bind(this);
      this.handleShowDetails = this.handleShowDetails.bind(this);
      this.onChange = this.onChange.bind(this);
      this.closeModal = this.closeModal.bind(this);
    }

  

  closeModal() {
    this.setState({popUpVisible: false});
    this.handleShowDetails();
  }

    componentDidMount() {
      this.getVenueList();
      this.getGameList();
      this.getQualityList();
      this.findHotLeads(this.state.location);
      if(this.state.open){
        document.body.style.overflow = 'hidden';
      }  
    }
    componentWillUnmount() {
      document.body.style.overflow = 'unset';
    }
 
    handleShowDetails(){
      this.findHotLeads(this.state.location)   
    }


    findHotLeads(location){ 
      this.setState({is_fetching: true})
      var temp = this.state.sortOrder
      var url = `${getLocationOrigin()}/sales/find_customers/?page=${this.state.page}&source=CM&sortColumn=${this.state.sortColumn}&sortOrder=${this.state.sortOrder}`;
      this.setState({loading:true})


      if(this.state.selected_venue.length > 0 ){
        var venue_list = []
        url = url + "&venue_id=" 
        for(var i in this.state.selected_venue)
        {
          venue_list.push(this.state.selected_venue[i])
        }
        url = url + venue_list
      }

      if(this.state.selected_source.length > 0 ){
        var source_list = []
        url = url + "&lead_source=" 
        for(var i in this.state.selected_source)
        {
          source_list.push(this.state.selected_source[i])
        }
        url = url + source_list
      }


      

      if(this.state.selectedLocation.sales_score_card.isFetching){
        url = url +"&location="+location


        

        if(this.state.selected_status.length > 0 ){
          var status_list = []
          url = url + "&status="
          for(var j in this.state.selected_status)
          {
            status_list.push(this.state.selected_status[j])
          }
          url = url + status_list
        }


        if(this.state.selected_game.length >0){
          var game_list = []
          url = url + "&game="
          for(var k in this.state.selected_game){
            game_list.push(this.state.selected_game[k])  
          }
          url = url + game_list
        }


        if(this.state.selected_quality.length >0){
          var quality_list = []
          url = url + "&quality="
          for(var l in this.state.selected_quality){
            quality_list.push(this.state.selected_quality[l])  
          }
          url = url + quality_list
        }


        this.state.selectedLocation.sales_score_card.isFetching = false
      }
      else{
        url = url +"&location="+location
        if(this.state.selected_status.length > 0 ){
          var status_list = []
          url = url + "&status="
          for(var j in this.state.selected_status)
          {
            status_list.push(this.state.selected_status[j])
          }
          url = url + status_list
        }
        

        if(this.state.selected_game.length >0){
          var game_list = []
          url = url + "&game="
          for(var k in this.state.selected_game){
            game_list.push(this.state.selected_game[k])  
          }
          url = url + game_list
        }


        if(this.state.selected_quality.length >0){
          var quality_list = []
          url = url + "&quality="
          for(var l in this.state.selected_quality){
            quality_list.push(this.state.selected_quality[l])  
          }
          url = url + quality_list
        }
        

      }
      

       const options = {...defaultOptions};
      
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
        if(data.results.length > 0){
          this.setState({
            sortOrder: temp,
            is_fetching: false, 
            lead_list: data.results,
            pageSize:data.page_size,
            rowCount:data.results_count,
            pages:data.num_pages ,
            lead_headings: Object.keys(data.results[0]), 
            loading:false
          })
        }
        else{
          this.setState({is_fetching: false, lead_list: data.results, loading:false,expected_payment:data.tag})
        }
        })
         .catch(error => error);
    }





    getQualityList(){
      const url = `${getLocationOrigin()}/court/get_quality/`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({quality_list: data.quality}))
         .catch(error => error);
    }


    getVenueList(){
      const url = `${getLocationOrigin()}/court/get_venues/`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => 
          this.setState({venue_list: data.results, status_list:data.status}))
         .catch(error => error);
    }

    getSourceList(){
      const url = `${getLocationOrigin()}/court/get_sources/`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => 
          this.setState({source_list: data.sources}))
         .catch(error => error);
    }

    getGameList(){
       const url = `${getLocationOrigin()}/court/get_games/`;
        const options = {...defaultOptions};
  
       return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => this.setState({game_list:data.results}))
          .catch(error => error);

     } 

     connectCall(call) {
      const url = `${getLocationOrigin()}/calls/connect_customer/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                          'customer_no': call.mobile_no_hidden,
                                          'source':'CM'
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(function(response){                     
            alert(response.message);
            // props.history.goBack();
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
     }  



    
      

    onSelect(optionsList, selectedItem) {
      var name = optionsList.name ;
      if(name=== 'venue'){
        this.state.temp_list.push(optionsList.id)
        this.setState({ selected_venue: this.state.temp_list,selected_name: name });
      }
      else if(name === 'game'){
        this.state.temp_list_game.push(optionsList.pk)
        this.setState({ selected_game:this.state.temp_list_game , selected_name: name});
      }
      else if(name === 'status'){
        this.state.temp_list_status.push(optionsList.id)
        this.setState({selected_status: this.state.temp_list_status, selected_name: name});
      }
      else if(name === 'quality'){
        this.state.temp_list_quality.push(optionsList.id)
        this.setState({selected_quality: this.state.temp_list_quality, selected_name: name});
      }
      else if(name == 'source'){
        this.state.temp_list_source.push(optionsList.source)
        this.setState({selected_source: this.state.temp_list_source, selected_name: name});

      }
    }

    onChange(dataItem,event){
      var name = event.dataItem.name
        
      if(name === 'venue'){
        this.setState({page:1, selected_venue:dataItem.map(x => x.id),selected_name: name }, () => this.findHotLeads(this.state.location) );
      }
      else if(name === 'game'){
        this.setState({page:1, selected_game:dataItem.map(x => x.pk), selected_name: name}, () => this.findHotLeads(this.state.location) );
      }
      else if(name === 'status' ){
        this.setState({page:1, selected_status: dataItem.map(x => x.id), selected_name: name}, () => this.findHotLeads(this.state.location)  );
      }
      else if(name === 'quality' ){
        this.setState({page:1, selected_quality: dataItem.map(x => x.id), selected_name: name}, () => this.findHotLeads(this.state.location)  );
      }
      else if(name === 'source'){
        this.setState({page:1, selected_source: dataItem.map(x => x.source), selected_name: name}, () => this.findHotLeads(this.state.location)  );
      } 
     
    }

    callBack(id) {
      var call = this.state.lead_list.find(temp => temp.customer_id_hidden == id)
      this.connectCall(call)
    }

    passToWhatsapp(props,mobile_no) {
      location.href = `whatsapp://send?phone=91${mobile_no}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`
    }

     openWhatsapp(mobile_no) {
      window.open(`https://web.whatsapp.com/send?phone=91${mobile_no}&lang=en&text=Hi%0A%3CCM%20name%3E%20from%20Sporthood%20here`,
        '_blank')
    }
  
    render() {      
      console.log('calling render*******')
      var loc = this.state.selectedLocation.sales_score_card.isFetching

      if(loc){
        var location = this.state.selectedLocation.sales_score_card.requested_venue_id
        this.findHotLeads(location)
        this.setState({isFetching:false,location:location})
      }


      $(".venue .searchBox").click(function(){

          $('.venue .optionListContainer').show();

      });

      var headings_list =  this.state.lead_headings.slice()
      
      
      
      headings_list.push("Actions");
      headings_list.push("Message");
     var csvData = [];
      var rows = this.state.lead_list.map(function(lead,index){
        var row = { ...lead }
        var headers = ["Customer","Program","Status","Mobile_no","Follow_up_date","Quality","Comment","Source"];
        // csvData[0] = headers;
        var csvHeader = ["customer","program","status","mobile_no","follow_up_date","quality","comment","source"];
        var j;
        var csv = []
        for(j=0;j<csvHeader.length;j++){
          if(csvHeader[j] == 'status'){
            var s = '' 
            {row[csvHeader[j]]==10 ? s = 'Response' : row[csvHeader[j]]==20 ? s = "Contact Later" : row[csvHeader[j]]==30 ? s = "Demo Scheduled" : row[csvHeader[j]]==40 ? s = "Did Not Demo" : row[csvHeader[j]]==50 ? s = "Verbal Confirmation" : row[csvHeader[j]]==70 ? s = "Paid" : row[csvHeader[j]]==80 ? s = "Dead Lead" : row[csvHeader[j]]==85 ? s = "Dropped" : row[csvHeader[j]]==90 ? s = "Dormant" : row[csvHeader[j]]==100 ? s = "Injured Customer" : row[csvHeader[j]]==120 ? s = "Demo Attended" :row[csvHeader[j]]==130 ? s = "Temporarily Inactive" : row[csvHeader[j]]==60 ? s = "Did Not Signup"  : s = "None"}
            csv.push(s);
          }
          else if(csvHeader[j] == 'mobile_no'){
            var s = row.mobile_no_hidden
            csv.push(s);
          }
          else{
            csv.push(row[csvHeader[j]]);
          }
        }
        csvData.push(csv);
        if(row.customer == ''){
          if((row.status == 110 || row.status == 50) && (row.follow_up_date >= moment().format('DD/MM/YYYY'))){
            row["customer"] = '<a target="_blank"'+'href="https://cm.sporthood.in/#/crud/customerDetails/'+row.customer_id_hidden+'">'+'__payment'+'</a>';
          }
          else{
            row["customer"] = '<a target="_blank"'+'href="https://cm.sporthood.in/#/crud/customerDetails/'+row.customer_id_hidden+'">'+'__'+'</a>';
          }
        }
        else{
          if((row.status == 110 || row.status == 50) && (row.follow_up_date >= moment().format('DD/MM/YYYY'))){
            row["customer"] = '<i class="fa fa-usd fa-x" style="color: green;">'+' '+'</i>'+'<a target="_blank"'+'href="https://cm.sporthood.in/#/crud/customerDetails/'+row.customer_id_hidden+'">'+row.customer+'</a>';
          }
          else{
            row["customer"] = '<a target="_blank"'+'href="https://cm.sporthood.in/#/crud/customerDetails/'+row.customer_id_hidden+'">'+row.customer+'</a>';            
          }
        }


        
        
        if(row.status == 10){
          row["status"] = '<p style = "color: black; background-color:#DF744A;" >' + "Response" + '</p>';
        }
        else if(row.status == 20){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Contact Later" + '</p>';
        }
        else if(row.status == 85){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Dropped" + '</p>';
        }
        else if(row.status == 90){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Dormant" + '</p>';
        }
        else if(row.status == 110){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Payment Due" + '</p>';
        }
        else if(row.status == 30){
          row["status"] = '<p style = "color: black; background-color:#F79E45;" >' + "Demo Scheduled" + '</p>';
        }
        else if(row.status == 40){
          row["status"] = '<p style = "color: black; background-color:#F79E45;" >' + "Did Not Demo" + '</p>';
        }
        else if(row.status == 50){
          row["status"] = '<p style = "color: black; background-color:#04BFB9;" >' + "Verbal Confirmation" + '</p>';
        }
        else if(row.status == 120){
          row["status"] = '<p style = "color: black; background-color:#F79E45;" >' + "Demo Attended" + '</p>';
        }
        else if(row.status == 130){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Temporarily Inactive" + '</p>';
        }
        else if(row.status == 100){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Injured Customer" + '</p>';
        }
        else if(row.status == 70 ){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Paid" + '</p>';
        }
        else if(row.status == 80 ){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Dead Lead" + '</p>';
        }
        else if(row.status == 60 ){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Did Not Signup" + '</p>';
        }
        else if(row.status == 160 ){
          row["status"] = '<p style = "color: black; background-color:#29c9cf;" >' + "Joined" + '</p>';
        }
        else if(row.status == 150 ){
          row["status"] = '<p style = "color: black; background-color:#29c9cf;" >' + "Location Problem" + '</p>';
        }

         else if(row.status == 141 ){
          row["status"] = '<p style = "color: black; background-color:#29c9cf;" >' + "Court Booking" + '</p>';
        }


        

        row["mobile_no"] = '<button style = "color: black; background-color:#EEA083;</style>" >' + row.mobile_no + '</button>';

        row["Actions"] = '<span class=badge badge-default style=cursor:pointer;background-color:#32CD32;color:white><i class="fa fa-phone fa-2x"></i></span>'; 
        row["Message"] = '<span><i style="cursor:pointer;font-size:2.1vw; color: rgb(37, 211, 102); margin-right: 0.5vw;" class="fa fa-whatsapp" aria-hidden="true"></i></span>'
        if(row.quality == 'Sure Payment'){
          row["quality"] = '<span><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i></span>';
        }
        if(row.quality == 'Highly Likely'){
          row["quality"] = '<span><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i></span>';
        }
        if(row.quality == 'May Pay'){
          row["quality"] = '<span><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i></span>';
        }
         if(row.quality == 'No Response'){
          row["quality"] = '<span><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i></span>';
        }
         if(row.quality == 'Will Not Pay'){
          row["quality"] = '<span><i class="fa fa-star" style="color: orange;"></i></span>';
        }
        
        return row
 

      });
      
    const headings = headings_list.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = element;//For react-table
      heading["displayName"] = element.charAt(0).toUpperCase() + element.slice(1);
      heading["Header"] = element.charAt(0).toUpperCase() + element.slice(1); //For react-table
      if(element == 'program' || element == 'mobile_no' || element == 'View' || element == 'Actions'){
        heading["sortable"] = false;
      }
      else{
        heading["sortable"] = true;
      }
      if(element == 'Actions'){
        heading["minWidth"] = 50;
      }else if(element == 'comment' || element == 'program'){
        heading["minWidth"] = 100;
      }else if(element == 'mobile_no'){
        heading["minWidth"] = 70;
      }else{
        heading["minWidth"] = 60;
      }
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });   
       
     this.state.lead_headings.map(function(key,index){
     });      
      
      
      const {
        statsTable, scoreCard,statsGraph
      } = this.props;

      var csvHeader = ["customer","program","status","mobile_no","follow_up_date","quality","comment","source"];

    return( 

        <div className="col-md-12 table-bordered" style={styles.table} style={{marginLeft: '8px'}}>

            <div style={styles.items} className=" col-md-2 col2" style={{marginTop: '8px',width:'18%'}}>
                              {this.state.status_list.length>0 && 
                          <Multiselect
                            placeholder="Status"
                            data={this.state.status_list}
                            textField='status'
                            onSelect={this.onSelect}
                            onChange={this.onChange} 
                            filter='contains'
            
                           />
                          } 
                        </div>

            <div style={styles.items} className="col-md-3 col2" style={{flexDirection:'column',marginTop: '8px',width:'18%'}}>
                  {this.state.game_list.length>0 && 
              <Multiselect
                id="3"  
                placeholder="Program"
                data={this.state.game_list}
                textField='game'
                onSelect={this.onSelect} 
                onChange={this.onChange}
                filter='contains' 
               />
              } 
            </div>      


            <div style={styles.items} className="col-md-3 col2" style={{flexDirection: 'column', marginTop: '8px',width:'18%'}}>
               {this.state.venue_list.length>0 && 
              <Multiselect
                id="1"
                placeholder="Venue"
                data={this.state.venue_list}
                textField='value'
                onSelect={this.onSelect} 
                onChange={this.onChange} 
                filter='contains'
               />
              } 
            </div>

            <div style={styles.items} className="col-md-3 col2" style={{flexDirection: 'column', marginTop: '8px',width:'18%'}}>
               {this.state.quality_list.length>0 && 
              <Multiselect
                placeholder="Quality"
                data={this.state.quality_list}
                textField='quality'
                onSelect={this.onSelect} 
                onChange={this.onChange} 
               />
              } 
            </div>

            <div style={styles.items} className="col-md-3 col2" style={{flexDirection:'column',marginTop: '8px',width:'18%'}}>
                  {this.state.source_list.length>0 && 
              <Multiselect
                id="3"  
                placeholder="Source"
                data={this.state.source_list}
                textField='source'
                onSelect={this.onSelect} 
                onChange={this.onChange}
                filter='contains' 
               />
              } 
            </div> 
          

          <div >
            <ReactHTMLTableToExcel
                        id="btn btn-lg"
                        className="download-table-xls-button"
                        table="table-to"
                        filename="Total Customers - Leads"
                        sheet="Total Customers - Leads"
                        buttonText="Download "/>
            {/*<CSVLink data={csvData} ><i className="fa fa-floppy-o fa-3x" aria-hidden="true" style={{color:'#04BFB9',marginTop: '5px'}}></i></CSVLink>*/}
            <i className="fa fa-refresh fa-2x" aria-hidden="true" onClick={this.handleShowDetails} style={{marginLeft:'1%',marginTop: '8px',color:'#04BFB9',cursor:'pointer'}}></i>
          </div>
          

          

          {this.state.loading === true ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}><CircularProgress /></div>
              </div>
               
          :

            <div style={{margin:10}}>



              <div className="row new-table" >    
                <div className="row col-md-12" style={styles.table} style={{marginLeft: '3px'}}>
                  <ReactTable
                    data={rows}
                    rowsText={this.state.rowCount.toString()}  //Workaround to store the total rows.
                    columns={headings}
                    showPagination={true}
                    showPaginationTop={true}
                    defaultPageSize={100}
                    minRows={0}
                    style={{backgroundColor:'#9370DB',marginRight: '6px'}}
                    filterable={false}
                    orderBy={true}
                    defaultFilterMethod= {(filter, row, column) => {
                      const id = filter.pivotId || filter.id
                      return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                    }}
                    manual  
                    pages = {this.state.pages}  
                    page = {this.state.page-1}
                    pageSizeOptions = {[100]}
                    showPageSizeOptions = {false}
                    manualPagination={true}
                    sorted={this.state.sortOption}
                    onPageChange={page => {
                       this.setState({page: page+1}, () => this.findHotLeads(this.state.location) )
                    }}
                  

                    onSortedChange = { sortOption => {
                       this.setState({sortOption:sortOption,  sortColumn: sortOption[0].id,sortOrder:sortOption[0].desc}, () => this.findHotLeads(this.state.location) )
                       

                    }}                 

                    getTrProps={(state, rowinfo, column) => {
                      var bgcolor = '#dcdcdc';
                      if (rowinfo!=undefined && rowinfo.row.hasOwnProperty("style_hidden")) {
                          var row_style = rowinfo.row["style_hidden"]
                          if(row_style!=null && row_style.indexOf('row-danger') != -1){
                            bgcolor = '#FFC8B8';
                          }else if(row_style!=null && row_style.indexOf('row-warning') != -1){
                            bgcolor = '#FFE699';
                          }
                      }              
                      return {
                        style: {
                          background: 'white',height:'50px'
                        }
                        
                        
                      };
                    }}

                    getTdProps={(state, rowInfo, column, instance) => {

                      return {

                        
                          onClick: (e, handleOriginal) => {
                              if(column.displayName === 'Mobile_no'){
                                this.setState({selected_customer_id:rowInfo.row.customer_id_hidden,popUpVisible:true,mobile_popup:true} )
                              }

                              if(column.displayName === 'Actions'){
                                this.setState({selected_customer_id:rowInfo.row.customer_id_hidden})
                                this.callBack(rowInfo.row.customer_id_hidden)
                              }

                              if(column.displayName === 'Message'){
                                this.openWhatsapp(rowInfo.row.mobile_no_hidden)
                              }

                              // IMPORTANT! React-Table uses onClick internally to trigger
                              // events like expanding SubComponents and pivots.
                              // By default a custom 'onClick' handler will override this functionality.
                              // If you want to fire the original onClick handler, call the
                              // 'handleOriginal' function.
                              if (handleOriginal) {
                                handleOriginal()
                            }
                          }

                      }
                    }}                    

                    >



                  {
                    //To show the record count on top  
                    (state, makeTable, instance) => {

                      let recordsInfoText = "";

                      const { filtered, pageRows, pageSize, sortedData, page } = state;

                      if (sortedData && sortedData.length > 0) {
                        let isFiltered = filtered.length > 0;

                        let totalRecords = state.rowsText;

                        let recordsCountFrom = page * pageSize + 1;

                        let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                        if (isFiltered){
                          recordsInfoText = `${totalRecords} filtered records`;
                        }
                        else {
                          recordsInfoText = `${totalRecords} records`;
                        }
                      } else {
                          recordsInfoText = "No records";
                        }
                      return (
                        <div className="main-grid">
                          <div className="above-table text-right">
                            <div className="col-sm-12 records-info">
                              <span className="">{recordsInfoText}</span>
                            </div>
                          </div>
                          {makeTable()}
                          
                        </div>

                      );
                    }
                  }
            </ReactTable>
                </div>
              </div>
            </div>
          }

          <table id="table-to" style={{fontSize:'0%',opacity:'0'}}>
              <tr> 
                {csvHeader.map((head)=>
                  <th>{head}</th>)}
              </tr>
                {csvData.map((data)=>
                  <tr>
                    { data.map((each)=>
                      <td >{each}</td>
                      )
                    }
                  </tr>
                  )}
                
            </table>

          { this.state.popUpVisible ?
            <div >
             <Modal 
                isOpen={this.state.popUpVisible}
                onRequestClose={this.closeModal}
                style={customStyles}

              >
                <button className ="btn" onClick={this.closeModal} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
                <CustomerDetails match={{"params":{"id":this.state.selected_customer_id, "page": this.state.page}}}
                />
              </Modal>
            </div>
            :
            ""
            
          }

        </div>       
      );
    }
  }
  
  export default ActiveCustomers;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/activeCustomers/ActiveCustomers.js